import React, { useEffect, useState } from 'react'

import { AxiosResponse } from 'axios'
import {
  Card,
  Grid,
  PercentageChart,
  RadioGroup,
  Row,
  Select,
  Span
} from 'components'
import { useModal } from 'hooks'
import useLoading from 'hooks/useLoading'
//import { CockpitServices, IAggregatedCockpitNgt1 } from 'services/NGT/Cockpit'
import { ContainerChart } from 'pages/NGT/Cockpit/components/Charts/ContainerChart/ContainerChart'
import { CockpitServices } from 'services/NGT/Cockpit'
import { COLORS, FORMAT, SPACING } from 'utils'

import { CardChart, TableCockPit } from '../../../components'
import {
  VerticalBarChart,
  PieChart,
  RoundedLineChart
} from '../../../components/Charts'
import { LoadingIcon } from 'components/Icons'

export interface RiscoAbertoProps {
  data: number[]
  labels: string[]
}

const ManagerialCockpitNgt1: React.FC = () => {
  const { showModal } = useModal()
  const { setLoading } = useLoading()
  const [serviceLevelData, setServiceLevelData] = useState<number[]>([])
  const [serviceLevelLabels, setServiceLevelLabels] = useState<string[]>([])
  const [currentRiskValueData, setCurrentRiskValueData] = useState<number[]>([])
  const [riskVsBlockingData, setRiskVsBlockingData] = useState<RiscoAbertoProps>({ data: [], labels: [] } as RiscoAbertoProps)
  const [riskIndicator, setRiskIndicator] = useState<boolean>(false)
  const [riskOpeningByTimeData, setRiskOpeningByTimeData] = useState<RiscoAbertoProps>({ data: [], labels: [] } as RiscoAbertoProps)
  const [selectSlaWalletTarget, setSelectSlaWalletTarget] = useState<number>(9)
  const [slaWalletTarget, setSlaWalletTarget] = useState<number[]>([])
  const [slaWalletData, setSlaWalletData] = useState<number[]>([])
  const [selectSlaPendencyTarget, setSelectSlaPendencyTarget] = useState<number>(9)
  const [slaPendencyTarget, setSlaPendencyTarget] = useState<number[]>([])
  const [slaPendencyData, setSlaPendencyData] = useState<number[]>([])

  const listOptionsTarget = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 },
    { label: '8', value: 8 },
    { label: '9', value: 9 },
    { label: '10', value: 10 },
    { label: '11', value: 11 },
    { label: '12', value: 12 }
  ]

  const labelsSlaChart = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
  ]

  const handleChangeSlaWallet = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectSlaWalletTarget(parseInt(e.target.value))
  }

  const handleChangeSlaPendency = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectSlaPendencyTarget(parseInt(e.target.value))
  }

  const getServiceLevelData = () => {
    setLoading('loading')

    CockpitServices()
      .getServiceLevel()
      .then(({ data }) => {
        setServiceLevelData(data.data)
        setServiceLevelLabels(data.labels)
        setLoading('idle')
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter dados: Nível de Atendimento',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        setLoading('idle')
      })
  }

  const getCurrentRiskValueData = () => {
    setLoading('loading')

    CockpitServices()
      .getCurrentRiskValue()
      .then(({ data }) => {
        setCurrentRiskValueData(data.data)
        setLoading('idle')
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter dados: Risco Atual',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        setLoading('idle')
      })
  }

  const getRiskVsBlockingValueData = () => {
    setLoading('loading')

    CockpitServices()
      .getRiskVsBlockingValue()
      .then(({ data }) => {
        setRiskVsBlockingData(data)
        setLoading('idle')
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter dados: Risco vs Bloqueio',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        setLoading('idle')
      })
  }

  const getRiskOpeningByTimeData = () => {
    setLoading('loading')

    CockpitServices()
      .getRiskOpeningByTime(riskIndicator)
      .then(({ data }) => {
        setRiskOpeningByTimeData(data)
        setLoading('idle')
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter dados: Abertura do Risco por Tempo',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        setLoading('idle')
      })
  }

  const getSlaWalletData = () => {
    setLoading('loading')

    CockpitServices()
      .getSlaWallet()
      .then(({ data }) => {
        data.data.forEach((monthData) => {
          setSlaWalletData((prev) => [...prev, monthData.diferencaDias])
        })

        setLoading('idle')
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter dados: SLA Carteira',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        setLoading('idle')
      })
  }

  const getSlaPendencyData = () => {
    setLoading('loading')

    CockpitServices()
      .getSlaPendency()
      .then(({ data }) => {
        data.data.forEach((monthData) => {
          setSlaPendencyData((prev) => [...prev, monthData.diferencaDias])
        })

        setLoading('idle')
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter dados: SLA Pendência',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
        setLoading('idle')
      })
  }

  // *** Código abaixo foi comentado devido a não implementação das rotas agregadas ***
  // GET DATA ROTAS AGREGADAS
  // const getInitialData = () => {
  //   CockpitServices()
  //     .aggregatedCockpitNgt1()
  //     .then((response: AxiosResponse<IAggregatedCockpitNgt1>) => {
  //       setServiceLevelData(response.data.cockpit_nivelAtendimento.data)
  //       setServiceLevelLabels(response.data.cockpit_nivelAtendimento.labels)
  //       setCurrentRiskValueData(response.data.cockpit_valorCalculoRisco.data)
  //       setRiskVsBlockingData(response.data.cockpit_versusRiscoBloqueio.data)
  //       response.data.cockpit_slaCarteira.data.forEach((monthData) => {
  //         slaWalletData.push(monthData.diferencaDias)
  //       })
  //       response.data.cockpit_slaPendencia.data.forEach((monthData) => {
  //         slaPendencyData.push(monthData.diferencaDias)
  //       })
  //     })
  //     .catch(() => {
  //       showModal({
  //         hideButtonCancel: true,
  //         message: 'Erro ao obter dados iniciais',
  //         txtButtonConfirm: 'Fechar',
  //         type: 'error'
  //       })
  //     })
  // }

  // useEffect(() => {
  //   getInitialData()
  //   fillSlaWalletTarget()
  //   fillSlaPendencyTarget()
  //   getRiskOpeningByTimeData()
  // }, [])

  const fillSlaWalletTarget = () => {
    for (let i = 0; i < 12; i++) {
      slaWalletTarget.push(selectSlaWalletTarget)
    }
  }

  const fillSlaPendencyTarget = () => {
    for (let i = 0; i < 12; i++) {
      slaPendencyTarget.push(selectSlaPendencyTarget)
    }
  }

  useEffect(() => {
    fillSlaWalletTarget()
    getSlaWalletData()
  }, [selectSlaWalletTarget])

  useEffect(() => {
    fillSlaPendencyTarget()
    getSlaPendencyData()
  }, [selectSlaPendencyTarget])

  useEffect(() => {
    getServiceLevelData()
    getCurrentRiskValueData()
    getRiskVsBlockingValueData()
    fillSlaWalletTarget()
    fillSlaPendencyTarget()
    getRiskOpeningByTimeData()
  }, [])

  useEffect(() => {
    getRiskOpeningByTimeData()
  }, [riskIndicator])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
      borderRadius={`0px 10px 0px 0px`}
    >
      <Grid
        gridCols="0.5fr 3.5fr 0.5fr 3.5fr"
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <div />
        <Select
          width="150px"
          marginLeft={SPACING.spacing30}
          label="Meta"
          defaultValue={9}
          value={selectSlaWalletTarget}
          listOptions={listOptionsTarget}
          onChange={(e) => {
            setSlaWalletTarget([])
            setSlaWalletData([])
            handleChangeSlaWallet(e)
          }}
        />

        <div />
        <Select
          width="150px"
          marginLeft={SPACING.spacing30}
          label="Meta"
          defaultValue={9}
          value={selectSlaPendencyTarget}
          listOptions={listOptionsTarget}
          onChange={(e) => {
            setSlaPendencyTarget([])
            setSlaPendencyData([])
            handleChangeSlaPendency(e)
          }}
        />
      </Grid>
      <Row
        alignItems="center"
        justifyContent="space-around"
        marginBottom={SPACING.spacing20}
      >
        <RoundedLineChart
          datasetsLabels={labelsSlaChart}
          datasetsTargetData={slaWalletTarget}
          datasetsData={slaWalletData}
          chartTitle="SLA Carteira"
        />
        <RoundedLineChart
          datasetsLabels={labelsSlaChart}
          datasetsTargetData={slaPendencyTarget}
          datasetsData={slaPendencyData}
          chartTitle="SLA Pendência"
        />
      </Row>

      <Span
        text="ABERTURA DO RISCO POR TEMPO"
        fontSize="20px"
        fontWeight="bold"
        marginTop={SPACING.spacing50}
        marginLeft="auto"
        marginRight="auto"
      />
      <RadioGroup
        row
        label="Indicador"
        defaultValue={riskIndicator}
        onChange={() => setRiskIndicator(!riskIndicator)}
        listOptions={[
          { label: 'Carteira', value: true },
          { label: 'Geral', value: false }
        ]}
      />
      {
        riskOpeningByTimeData.data.length > 0 ?
          <TableCockPit riskOpeningByTimeData={riskOpeningByTimeData} />
          :
          <Row
            alignItems="center"
            justifyContent="center"
            marginBottom={SPACING.spacing50}
            marginTop={SPACING.spacing20}
          >
            <LoadingIcon />
          </Row>
      }

      <Row
        alignItems="center"
        justifyContent="center"
        marginTop={SPACING.spacing50}
      >
        <CardChart titleCard="Nível de Atendimento">
          {
            serviceLevelData.length > 0 && serviceLevelLabels.length > 0 ?
              <PercentageChart
                backgrounds={['#C2C2C2', '#00529C', '#000000']}
                values={[serviceLevelData[0], serviceLevelData[1], serviceLevelData[2]]}
                labels={[serviceLevelLabels[0], serviceLevelLabels[1], serviceLevelLabels[2]]} // ["Contratos á Analisar", "Contratos Analisados"]
              />
              :
              <Row
                alignItems="center"
                justifyContent="center"
                marginBottom={SPACING.spacing50}
                marginTop={SPACING.spacing20}
              >
                <Span
                  text={`Não foi possível obter os dados do gráfico Nível de Atendimento`}
                  fontSize="1rem"
                  fontWeight="bold"
                  textAlign='center'
                  color={COLORS.info}
                />
              </Row>
          }
        </CardChart>

        <CardChart titleCard="Risco atual">
          {
            currentRiskValueData.length > 0 ?
              <PieChart
                values={[currentRiskValueData[0], currentRiskValueData[1], currentRiskValueData[0] + currentRiskValueData[1]]}
                labels={[
                  FORMAT.currency(currentRiskValueData[0]) + ' Sem Prescrição',
                  FORMAT.currency(currentRiskValueData[1]) + ' Com Prescrição',
                  FORMAT.currency(currentRiskValueData[1] + currentRiskValueData[0]) + ' Total Geral Risco'
                ]}
              />
              :
              <Row
                alignItems="center"
                justifyContent="center"
                marginBottom={SPACING.spacing50}
                marginTop={SPACING.spacing20}
              >
                <Span
                  text={`Não foi possível obter os dados do gráfico Risco Atual`}
                  fontSize="1rem"
                  fontWeight="bold"
                  textAlign='center'
                  color={COLORS.info}
                />
              </Row>
          }
        </CardChart>

        <CardChart titleCard="Risco VS Bloqueio (FR)">
          {
            riskVsBlockingData.data.length > 0 ?
              <VerticalBarChart
                values={[
                  riskVsBlockingData.data[0],
                  riskVsBlockingData.data[1],
                  riskVsBlockingData.data[2],
                  riskVsBlockingData.data[3],
                ]}
                labelsData={[
                  FORMAT.currency(riskVsBlockingData.data[0]) + ` ${riskVsBlockingData.labels[0]}`,
                  FORMAT.currency(riskVsBlockingData.data[1]) + ` ${riskVsBlockingData.labels[1]}`,
                  FORMAT.currency(riskVsBlockingData.data[2]) + ` ${riskVsBlockingData.labels[2]}`,
                  FORMAT.currency(riskVsBlockingData.data[3]) + ` ${riskVsBlockingData.labels[3]}`,
                ]}
              />
              :
              <Row
                alignItems="center"
                justifyContent="center"
                marginBottom={SPACING.spacing50}
                marginTop={SPACING.spacing20}
              >
                <Span
                  text={`Não foi possível obter os dados do gráfico Risco VS Bloqueio`}
                  fontSize="1rem"
                  fontWeight="bold"
                  textAlign='center'
                  color={COLORS.info}
                />
              </Row>
          }
        </CardChart>
      </Row>
    </Card>
  )
}

export default ManagerialCockpitNgt1
